import React from 'react';
//import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import DownloadIcon from '@mui/icons-material/Download';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import './Button.scss';
import Loader from '../../Loader/Loader';

const CustomButton = ({
  buttonType,
  onClick = () => {},
  btnLabel = '',
  className = '',
  pill = false,
  customIcon,
  loading = false,
  disabled,
  ...rest
}) => {
  const buttonClasses = {
    download: 'Download-btn btn',
    search: 'Search-btn btn',
    upload: 'Upload-btn btn',
    success: 'Upload-btn btn',
    delete: 'Delete-btn btn',
    default: 'default-btn btn',
  };

  const buttonClass = buttonClasses[buttonType] || buttonClasses.default;

  const renderIcon = () => {
    if (buttonType === 'upload' || buttonType === 'success') {
      return customIcon || <CloudUploadIcon fontSize="small" />;
    }
    if (buttonType === 'download') {
      return <CloudDownloadIcon fontSize="small" />;
    }
    return null;
  };

  const renderLabel = () => {
    if (buttonType === 'upload' || buttonType === 'success') {
      return btnLabel || 'UPLOAD';
    }
    if (buttonType === 'download') {
      return 'DOWNLOAD';
    }
    return btnLabel || buttonType?.toUpperCase();
  };

  return (
    <button onClick={onClick} className={`${buttonClass} ${className} ${pill ? 'pill-btn' : ''}`} disabled={disabled} {...rest}>
      {/* {renderLabel()} {renderIcon()} */}
      {loading ? <Loader size="button-loader" color={disabled? "default": "white"}/> : renderLabel()} {/* Use Loader component if loading */}
      {!loading && renderIcon()}
    </button>
  );
};

export default CustomButton;
